import "dotenv/config";

import * as React from "react";
import * as ReactDOM from "react-dom";
import createPlugin from "bugsnag-react";

import getMuiTheme from "material-ui/styles/getMuiTheme";
import { grey800 } from "material-ui/styles/colors";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";

import BackOffice from "./app/BackOffice";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

import bugsnagClient from "./bugsnagClient";

const ErrorBoundary = bugsnagClient.use(createPlugin(React));

const muiTheme = getMuiTheme({
  tableHeader: {
    borderColor: grey800,
  },
  tableHeaderColumn: {
    height: 30,
    spacing: 24,
  },
  tableRow: {
    stripeColor: "#ddd",
    hoverColor: "#eee",
    selectedColor: "#ccc",
    height: 30,
  },
  tableRowColumn: {
    height: 30,
    spacing: 24,
  },
  checkbox: {
    checkedColor: "#313d61",
    boxColor: "#999",
  },
});
ReactDOM.render(
  <ErrorBoundary>
    <MuiThemeProvider muiTheme={muiTheme}>
      <BackOffice />
    </MuiThemeProvider>
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
